/**
 * computation-step.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { AlgorithmStep } from "./algorithm-step";

export class ComputationStep extends AlgorithmStep
{
  // Computation steps have no additional features over algorithm steps.
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/structure/computation-step.ts